import { BryqChip } from './BryqChip';
import { EmailChip } from './EmailChip';
import { FeedbackChip } from './FeedbackChip';
import { NotesChip } from './NotesChip';

/**
 * The per-candidate chip row: 📝 notes, 🧠 Bryq, ✉️ emails, 📋 feedback.
 *
 * Every card on the board carried the same four in the same order, written out four lines at a
 * time in seven places. One component instead, so a new chip is added once rather than seven
 * times and no card can quietly end up with three of the four.
 *
 * Each chip renders nothing outside its own provider, so a card that is rendered in isolation
 * (a test, a storybook) shows an empty row rather than dead buttons.
 */
export function CandidateChips({
  candidateName,
  opportunityId,
}: {
  candidateName: string;
  opportunityId: string;
}) {
  return (
    <>
      <NotesChip candidateName={candidateName} opportunityId={opportunityId} />
      <BryqChip candidateName={candidateName} opportunityId={opportunityId} />
      <EmailChip candidateName={candidateName} opportunityId={opportunityId} />
      <FeedbackChip candidateName={candidateName} opportunityId={opportunityId} />
    </>
  );
}
